const monthDateTimeFormat = new Intl.DateTimeFormat('nl-NL', { month: 'long' });
const fullDateTimeFormat = new Intl.DateTimeFormat('nl-NL', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
});

export default {
    methods: {
        formatYear(dateArg) {
            const date = new Date(dateArg);
            return date.getFullYear();
        },

        formatMonth(monthId, year) {
            const date = new Date(year || new Date().getFullYear(), monthId);
            return monthDateTimeFormat.format(date);
        },

        formatDate(date) {
            return fullDateTimeFormat.format(new Date(date));
        }
    }
};
